<template>
  <hic-dialog title="质控记录" :close-on-click-modal="true" :visible="visible" @open="open" @close="cancel" append-to-body width="60rem">
    <el-table @filter-change="filterChange" @sort-change="sortChange" :data="logs" stripe height="30rem" v-loading="meta.loading" row-key="id" default-expand-all>
      <el-table-column sortable label="结果" prop="submitTime" width="100">
        <template slot-scope="{ row }">
          <el-tag v-if="row.qcState == '不通过'" type="danger" size="mini" hit>{{ row.qcState }}</el-tag>
          <el-tag v-else-if="row.qcState == '通过'" type="success" size="mini" hit>{{ row.qcState }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column column-key="tmplCode" :filters="dict.MrTemplate" :filter-multiple="false" label="文书类别" prop="tmplCode" align="center">
        <template slot-scope="{ row }">
          {{ row.tmplCode | dictText("MrTemplate") }}
        </template>
      </el-table-column>
      <el-table-column sortable label="版本" prop="ver" align="center" width="80"></el-table-column>
      <el-table-column column-key="qcType" :filters="dictEnum.MrQCType" :filter-multiple="false" label="质控类型" prop="qcType" align="center"></el-table-column>
      <el-table-column column-key="errLevel" :filters="dictEnum.MrQCErrLevel" :filter-multiple="false" label="问题级别" prop="errLevel" align="center"></el-table-column>
      <el-table-column label="问题描述" width="120" prop="content" align="center">
        <template slot-scope="{row}">
          <div v-for="(cm, index) in comments(row.content)" :key="index" class="left">{{ cm.desc }}</div>
        </template>
      </el-table-column>
      <el-table-column label="质控人" prop="qcUserName" align="center"></el-table-column>
      <el-table-column sortable label="时间" prop="submitTime" align="center" width="100">
        <template slot-scope="{ row }">
          <span>{{ row.qcTime | fmtDate }}</span>
        </template>
      </el-table-column>
    </el-table>
  </hic-dialog>
</template>

<script>
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      // pagination: () => import("@/components/_com/pagination"),
    },
    props: {
      isMrView: Boolean,
      visible: Boolean,
      id: Number,
      mrMain: Object,
    },
    data() {
      return {
        title: "",
        meta: {
          loading: false,
          showTimeRule: false,
        },
        value: "",
        keyword: "",
        groupInfo: {},
        entities: {},
        condition: {
          pageIndex: 0,
          pageSize: 10,
        },
        logs: [],
        details: [],
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "dictEnum"]),
    },
    methods: {
      open() {
        this.logs = [];
        this.details = [];
        this.meta.loading = true;
        this.$api.QcLog.query({ mainId: this.mrMain.id, sort: "id", asc: false })
          .then((res) => {
            this.logs = res.items;
            this.logs.forEach((log) => {
              this.$api.QcLogDetail.query({ mainId: log.id }).then((details) => {
                this.$set(log, "children", details.items);
                this.details.push(...details.items);
              });
            });
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      filterChange(obj) {
        let key = Object.keys(obj)[0];
        let value = obj[key][0];
        this.condition[key] = value;
        this.getDetailInfo();
      },
      sortChange(obj) {
        //sort=opRecordId&asc=false
        // console.log('obj===',JSON.stringify(obj))

        this.condition.sort = obj.column.property;
        this.condition.asc = obj.column.order.indexOf("asc") > -1 ? true : false;
        this.getDetailInfo();
      },
      cancel() {
        this.$emit("close");
        this.$emit("update:visible", false);
      },
      comments(str) {
        let cms = []
        if (str) {
          try {
            cms = JSON.parse(str)
          } catch (error) {
            console.log("质控详细内容不是合法JSOn", error)            
          }
        }
        return cms
      },
      async getDetailInfo() {
        this.meta.loading = true;
        this.condition.mainId = this.id;
        if (this.isMrView) {
          let data = {
            mainId: this.id,
            qcState: "待质控",
          };
          let res = await this.$api.queryQuality(data);
          let list = res && res.items ? res.items : [];
          if (list.length > 0) {
            this.condition.mainId = list[0].id;
          } else {
            this.entities = [];
            this.meta.loading = false;
            return;
          }
        }
        this.$api
          .getQualityDetail(this.condition)
          .then((res) => {
            this.entities = res;
            this.meta.loading = false;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
    },
  };
</script>

<style scoped>
  .el-row {
    margin-bottom: 10px;
  }

  .el-row:last-child {
    margin-bottom: 0px;
  }

  .ztitle {
    margin-top: 10px;
    color: #66b1ff;
  }
  .inputnw .el-input {
    width: 4rem !important;
  }
  .headtitle {
    background-color: red !important;
  }
</style>
